import React from "react";
import styles from "./style.module.scss";
import {
  PinMap,
  PeopleFill,
  FilePost,
  TagsFill,
  ImageFill,
  CupHot,
  Bell,
} from "react-bootstrap-icons";
import { ModuleCard, Loader } from "../../../../components/ui";
import { useAuth } from "../../../../context/AuthProvider";

const CommonDashboard = () => {
  const { selectedProject, allowedModules } = useAuth();

  const moduleIconHandler = (moduleName) => {
    console.log("moduleName", moduleName);
    if (moduleName === 1) {
      return (
        <>
          <PinMap size={45} color="var(--secondaryColor)" />
        </>
      );
    } else if (moduleName === 2) {
      return (
        <>
          <PeopleFill size={45} color="var(--secondaryColor)" />
        </>
      );
    } else if (moduleName === 4) {
      return (
        <>
          <FilePost size={45} color="var(--secondaryColor)" />
        </>
      );
    } else if (moduleName === 3 || moduleName === 5) {
      return (
        <>
          <TagsFill size={45} color="var(--secondaryColor)" />
        </>
      );
    } else if (moduleName === 7) {
      return (
        <>
          <ImageFill size={45} color="var(--secondaryColor)" />
        </>
      );
    } else if (moduleName === 12) {
      return (
        <>
          <CupHot size={45} color="var(--secondaryColor)" />
        </>
      );
    } else if (moduleName === 13) {
      return (
        <>
          <Bell size={45} color="var(--secondaryColor)" />
        </>
      );
    } else if (moduleName === 14) {
      return (
        <>
          <ImageFill size={45} color="var(--secondaryColor)" />
        </>
      );
    } else if (moduleName === 16) {
      return (
        <>
          <TagsFill size={45} color="var(--secondaryColor)" />
        </>
      );
    } else if (moduleName === 15) {
      return (
        <>
          <FilePost size={45} color="var(--secondaryColor)" />
        </>
      );
    } else {
      return null;
    }
  };

  // Show loader while data is being fetched
  if (allowedModules === null) {
    return (
      <div className={styles.commonDashboardPage}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "300px",
            gap: "20px",
          }}
        >
          <Loader />
          <p
            style={{
              fontSize: "16px",
              color: "#666",
              textAlign: "center",
            }}
          >
            Loading your dashboard...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.commonDashboardPage}>
      {selectedProject &&
      selectedProject.modules &&
      selectedProject.modules.length > 0 ? (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
          {selectedProject.modules.map((module, moduleIndex) => (
            <ModuleCard
              icon={moduleIconHandler(module.id)}
              title={module.name}
              id={module.id}
              key={`${selectedProject.id}-${module.id}`}
              link={module?.link || "#"}
            />
          ))}
        </div>
      ) : allowedModules && allowedModules.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            padding: "50px 20px",
            color: "#666",
          }}
        >
          <h2>No modules available</h2>
          <p>
            You don't have access to any modules at the moment. Please contact
            your administrator.
          </p>
        </div>
      ) : (
        <div
          style={{
            textAlign: "center",
            padding: "50px 20px",
            color: "#666",
          }}
        >
          <h2>Select a project</h2>
          <p>
            Please select a project from the dropdown to view available modules.
          </p>
        </div>
      )}
    </div>
  );
};

export default CommonDashboard;
